import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue';
import Application from '../views/Application.vue';
import Certificates from '../views/Certificates.vue';
import Menu from '../views/Menu.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/menu',
    name: 'Menu',
    component: Menu,
  },
  {
    path: '/application',
    name: 'Application',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Application,
  },
  {
    path: '/certificates',
    name: 'Certificates',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Certificates,
  },
];

let lastPosition: number | undefined;

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from) {
    const f = () => {
      // return { top: 1000, left: 0 };
      if (to.hash) {
        const elem = document.getElementById(to.hash.slice(1));
        if (elem) {
          const a = document.documentElement.scrollTop
            + elem.getBoundingClientRect().top;
          return {
            top: a,
          };
        }
      }
      if (to.path === '/' && lastPosition !== undefined) {
        return { top: lastPosition, left: 0 };
      }
      return { top: 0, left: 0 };
    };
    return new Promise((resolve) => {
      if (from.path === '/') {
        lastPosition = document.documentElement.scrollTop;
      }
      setTimeout(() => resolve(f()), 550);
    });
  },
});

export default router;
